import {Component, Input, OnInit} from '@angular/core';
import {OnlineVorhersageBericht} from '../../../../../../../model/vorhersagen/radiobremen-wetterbericht';

@Component({
  selector: 'app-radiobremen-online-bericht',
  templateUrl: './radiobremen-online-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class RadiobremenOnlineBerichtComponent {

  @Input() onlineVorhersageBericht: OnlineVorhersageBericht;

}
